import "./style/_app.scss";
import React, { lazy, Suspense, useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from "./component/Header";
import { Spin } from "antd";

import ReactGA from 'react-ga4';
import Resume from "./pages/resume/Resume";

ReactGA.initialize('G-J2GW3DKBXL');

const Landing = lazy(() => import("./pages/Landing"));
const Blog = lazy(() => import("./pages/blog/Blog"));
const BlogDetails = lazy(() => import("./pages/blog/BlogDetails"));
const Videos = lazy(() => import("./pages/videoTuts/Video"));

const App = () => {
  const [theme, setTheme] = useState(false);

  const themeChange = () => {
    setTheme(!theme);
  };

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: window.location.href, title: window.location.pathname });
  }, [])
  
  return (
    <Router>
      <Suspense
        fallback={
          <div
            style={{
              // background: "red",
              width: "100%",
              height: "100vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#0d1117",
            }}
          >
            <Spin />
          </div>
        }
      >
        <div
        // className={theme ? "appConatinerDark" : "appConatiner"}
        >
       
      
          <Header theme={theme} themeChange={() => themeChange()} />
          <Routes>
            <Route path="/" element={<Landing theme={theme} />} />
            <Route path="/video" element={<Videos />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:title" element={<BlogDetails />} />
            <Route path="/resume" element={<Resume />} />
          </Routes>
        </div>
      </Suspense>

      
    </Router>
  );
};

export default App;